<template>
  <!-- 简介 -->
  <transition name="info">
    <div
      v-if="show"
      :class="
        isIphoneX
          ? 'x-css info fixed cursor-default'
          : 'info fixed cursor-default'
      "
    >
      <i
        class="iconfont icon-close cursor-pointer absolute"
        aria-hidden="true"
        @click.stop="close"
      />
      <div class="text-right">
        <div class="info-title text-left w-full">
          <h5 class="leading-tight px-8 overflow-hidden text-justify">
            {{ data.name }}
          </h5>
        </div>
        <swiper
          v-if="!isMobile"
          class="info-box text-right"
          :options="swiperOption"
        >
          <swiper-slide class="text">
            <MarkdownViewer
              class="info-content text-left text-justify"
              :emptyText="'暂无数据'"
              :content="data.content"
            ></MarkdownViewer>
          </swiper-slide>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
        <div class="info-box text-right px-8" v-else>
          <MarkdownViewer
            class="info-content text-left text-justify"
            :emptyText="'暂无数据'"
            :content="data.content"
          ></MarkdownViewer>
        </div>
        <div
          v-if="data.ceramic_id && ((isMobile && isMiniprogram) || !isMobile)"
          class="more text-center cursor-pointer"
          @click.stop="more"
        >
          更多 | MORE
        </div>
      </div>
    </div>
  </transition>
  <!-- 简介 -->
</template>

<script>
import MarkdownViewer from '@/components/common/MarkdownViewer'
import wx from 'weixin-js-sdk'
export default {
  name: 'InfoBar',
  components: {
    MarkdownViewer
  },
  props: {
    show: Boolean,
    data: Object
  },
  computed: {
    isMobile() {
      let res = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return res
    },
    isMiniprogram() {
      return (
        navigator.userAgent.match(/miniprogram/i) ||
        window.__wxjs_environment === 'miniprogram'
      )
    },
    isIphoneX() {
      return (
        /iphone/gi.test(navigator.userAgent) &&
        (screen.height == 812 && screen.width == 375)
      )
    }
  },
  data() {
    return {
      videoAutoplay: false,

      swiperOption: {
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        mousewheel: true
      }
    }
  },
  methods: {
    close() {
      this.$parent.showModal = null
    },
    more() {
      if (this.isMiniprogram) {
        wx.miniProgram.navigateTo({
          url: `/pages/ceramic/detail?uuid=${this.data.ceramic_id}`
        })
      } else {
        // https://www.yyc.dev.zdbx.net/ceramic?uuid=d77c5600964411e9884f458eb0b967d4
        let url = `${process.env.VUE_APP_WWW_ENDPOINT}ceramic`
        let query = `?uuid=${this.data.ceramic_id}`
        window.open(url + query)
      }
    }
  }
}
</script>

<style scoped lang="scss">
//简介的样式
.info-enter-active,
.info-leave-active {
  transition: all 0.35s;
  -moz-transition: all 0.35s; /* Firefox 4 */
  -webkit-transition: all 0.35s; /* Safari 和 Chrome */
  -o-transition: all 0.35s; /* Opera */
}
.info-enter, .info-leave-to/* .drawer-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.info {
  width: 25rem;
  z-index: 101;
  top: 3.8rem;
  right: 6.25rem;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;

  .info-box {
    max-height: 50vh;
    font-size: 0.8rem;
  }
  .info-title {
    font-size: 1.25rem;
    padding-bottom: 0.725rem;
    line-height: 1.5;
    h5 {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
  .info-content {
    line-height: 1.5;
    font-size: 0.875rem;
    padding-bottom: 1rem;
  }
}
.poi-info.info {
  width: 25rem;
  top: 10%;
  right: 50%;
  margin-right: -8rem;
}

.icon-close {
  width: 1.25rem;
  height: 1.25rem;
  line-height: 1.25rem;
  top: 0rem;
  right: -1.25rem;
  font-size: 0.9rem;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
  &:hover {
    color: #979797;
  }
}
.more {
  padding: 0.5rem;
  border: 1px solid #fff;
  color: #fff;
  display: inline-block;
  width: auto;
  font-size: 0.9rem;
  margin-top: 1rem;
}

.h5 {
  .info {
    left: 0;
    right: 0;
    top: 50%;
    bottom: 0;
    width: 100%;
    height: auto;
    margin-left: 0;
    border-radius: 0.4rem 0.4rem 0 0;
    background-color: #fff;
    color: #555;
  }
  .icon-close {
    top: 0rem;
    right: 0rem;
    width: 2.4rem;
    height: 2.4rem;
    line-height: 2.4rem;
    color: #000;
    background-color: rgba(0, 0, 0, 0);
    z-index: 2;
  }
  .info-box {
    max-height: 35vh;
    overflow-y: scroll;
  }
  .more {
    border: 1px solid #555;
    color: #555;
  }
  .swiper-scrollbar {
    display: none;
  }
}
.x-css {
  .info-box {
    max-height: 31vh;
  }
}

.swiper-slide.text {
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 2rem;
  > .content {
    > .title {
      margin: 0;
      text-align: center;
      margin-bottom: 0.75em;
    }
    > p,
    blockquote {
      line-height: 2;
      text-indent: 2em;
    }
    blockquote {
      background-color: #ddd;
      margin-left: 2em;
    }
  }
}
</style>
